import type React from "react";
import { useState } from "react";

import { ProtocolView } from "routes/patients/PatientProfile/components/Protocol";
import { ProtocolContext } from "utils/contexts";

export const Protocol: React.FC = () => {
  const [selectedDayMobile, setSelectedDayMobile] = useState(null);

  return (
    <ProtocolContext.Provider
      value={{
        selectedDayMobile,
        setSelectedDayMobile,
      }}
    >
      <ProtocolView />
    </ProtocolContext.Provider>
  );
};
